<div class="tabs-navigation">
  @for (tab of config.tabs; track tab.id) {
    <button
      class="tab-button"
      [class.active]="isTabActive(tab.id)"
      (click)="setActiveTab(tab.id)"
      type="button"
    >
      {{ tab.label }}
    </button>
  }
</div>
